'use strict';

/**
 * library
 */
import imagesLoaded from 'imagesloaded';
imagesLoaded.makeJQueryPlugin($);
import 'slick-carousel';

/**
 * module
 */
import { anchor } from './module/_anchor';
import { disabled } from './module/_disabled';
import { faq } from './module/_faq';
import { fitimg } from './module/_fitimg';
import { header } from './module/_header';
import { hover } from './module/_hover';
import { inview } from './module/_inview';
import { justHeight } from './module/_justHeight';
import { modal } from './module/_modal';
import { nav } from './module/_nav';
import { responsive } from './module/_responsive';
import { svg } from './module/_svg';
import { toggle } from './module/_toggle';

/**
 * main
 */
const main = (() => {
    /**
     * loaded
     */
    const loaded = () => {
        setTimeout(() => {
            $('body').addClass('is-loaded');
        }, 200);
    };

    /**
     * init
     */
    const init = () => {
        anchor.init();
        disabled.init();
        faq.init();
        fitimg.init();
        header.init();
        hover.init();
        inview.init();
        justHeight.init();
        modal.init();
        nav.init();
        responsive.init();
        svg.init();
        toggle.init();

        slicks();

        $(window).on('resize', () => {
            setTimeout(() => {
                slicks();
            }, 100);
        });
    };

    const slicks = () => {
        $('.js-carousel-hero')
            .not('.slick-initialized')
            .slick({
                arrows: false,
                fade: true,
                autoplay: true,
                autoplaySpeed: 4000,
                speed: 1000,
                dots: false
            });
    };

    // public
    return {
        init: init,
        loaded: loaded
    };
})();

$(() => {
    main.init();

    $('body')
        .imagesLoaded()
        .done(instance => {
            main.loaded();
        })
        .fail(() => {
            main.loaded();
        });
});
